export class HarmonyPadPatternStrategy {
  generate(ctx, chord, oct, baseDegree, rand, bpb, genre) {
    if (genre === 'ambient') return this._genAmbientPad(ctx, chord, oct, baseDegree, rand, bpb);
    if (genre === 'cinematic') return this._genCinematicPad(ctx, chord, oct, baseDegree, rand, bpb);
    return this._genHarmony(ctx, chord, oct, baseDegree, rand, bpb);
  }

  _genHarmony(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    const numNotes = rand() < 0.4 ? 1 : 2;
    for (let i = 0; i < numNotes && i < chord.length; i++) {
      pattern.push({ beat: i * 0.05, note: ctx.noteFromSemitone(chord[i], oct), duration: (bpb - 0.5) * ctx.beatDuration + rand() * 1.0 });
    }
    if (rand() < 0.3 && chord.length > 2) {
      pattern.push({ beat: 0.02, note: ctx.noteFromSemitone(chord[2], oct), duration: (bpb - 1) * ctx.beatDuration + rand() });
    }
    return pattern;
  }

  _genAmbientPad(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    for (let i = 0; i < Math.min(chord.length, 3); i++) {
      pattern.push({ beat: i * 0.03, note: ctx.noteFromSemitone(chord[i], oct), duration: bpb * ctx.beatDuration * (1.5 + rand() * 1.0) });
    }
    if (rand() < 0.4) {
      const upperTone = chord[0] + 14;
      pattern.push({ beat: bpb * 0.3, note: ctx.noteFromSemitone(upperTone, oct), duration: bpb * ctx.beatDuration * 0.8 });
    }
    return pattern;
  }

  _genCinematicPad(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    for (let i = 0; i < Math.min(chord.length, 4); i++) {
      pattern.push({ beat: i * (bpb / (chord.length + 1)), note: ctx.noteFromSemitone(chord[i % chord.length], oct), duration: bpb * ctx.beatDuration * (0.8 + rand() * 0.5) });
    }
    return pattern;
  }
}
